export const SET_TAB_INDEX = 'SET_TAB_INDEX';

export const SET_CURRENT_POLYGON_IDS = 'SET_CURRENT_POLYGON_IDS';
export const SET_CURRENT_POLYGON_ID = 'SET_CURRENT_POLYGON_ID';
export const SET_POLYGONS_AND_TITLES = 'SET_POLYGONS_AND_TITLES';

export const FETCH_POLYGONS_REQUEST = 'FETCH_POLYGONS_REQUEST';
export const FETCH_POLYGONS_SUCCESS = 'FETCH_POLYGONS_SUCCESS';
export const FETCH_POLYGONS_FAILURE = 'FETCH_POLYGONS_FAILURE';

export const FETCH_INTERSECTIONS_REQUEST = 'FETCH_INTERSECTIONS_REQUEST';
export const FETCH_INTERSECTIONS_SUCCESS = 'FETCH_INTERSECTIONS_SUCCESS';
export const FETCH_INTERSECTIONS_FAILURE = 'FETCH_INTERSECTIONS_FAILURE';

export const FETCH_NEARBY_REQUEST = 'FETCH_PARCEL_NEARBY_REQUEST';
export const FETCH_NEARBY_SUCCESS = 'FETCH_PARCEL_NEARBY_SUCCESS';
export const FETCH_NEARBY_FAILURE = 'FETCH_PARCEL_NEARBY_FAILURE';

export const FETCH_PLANNING_REQUEST = 'FETCH_PLANNING_REQUEST';
export const FETCH_PLANNING_SUCCESS = 'FETCH_PLANNING_SUCCESS';
export const FETCH_PLANNING_FAILURE = 'FETCH_PLANNING_FAILURE';

export const FETCH_VALUE_REQUEST = 'FETCH_VALUE_REQUEST';
export const FETCH_VALUE_SUCCESS = 'FETCH_VALUE_SUCCESS';
export const FETCH_VALUE_FAILURE = 'FETCH_VALUE_FAILURE';

export const FETCH_AREA_INFO_REQUEST = 'FETCH_AREA_INFO_REQUEST';
export const FETCH_AREA_INFO_SUCCESS = 'FETCH_AREA_INFO_SUCCESS';
export const FETCH_AREA_INFO_FAILURE = 'FETCH_AREA_INFO_FAILURE';
